<template>
  <div class="home">
    <!-- HERO -->
    <section class="hero">
      <div class="hero-inner">
        <div class="hero-eyebrow">Xster · Personal Realm</div>
        <h1 class="hero-title">
          <span>在代码与创作的</span>
          <span class="hero-title-accent">交界处</span>
          <span>做点有意思的事。</span>
        </h1>
        <p class="hero-sub">
          Programmer · Maker · Visual Tinkerer
        </p>
        <div class="hero-cta">
          <el-button type="primary" size="large" @click="$router.push('/work')">
            看作品 →
          </el-button>
          <el-button size="large" plain @click="$router.push('/contact')">
            联系我
          </el-button>
        </div>
        <div class="hero-meta">
          <span class="meta-dot" /> 当前折腾中:HIT 计时器 v2 · Polaroid 移模实验
        </div>
      </div>
    </section>

    <!-- ABOUT -->
    <section class="about">
      <div class="section-inner">
        <div class="section-label">01 — About</div>
        <p class="about-text">
          我是写代码的,也是玩宝丽来移模的。白天折腾 Web 工具,晚上窝在暗房。
          比起"专业",我更愿意被记住为<span class="hl">那个什么都会折腾一下的人</span>。
        </p>
      </div>
    </section>

    <!-- SELECTED WORK -->
    <section class="work">
      <div class="section-inner">
        <div class="section-header">
          <div class="section-label">02 — Selected Work</div>
          <router-link to="/work" class="section-more">全部作品 →</router-link>
        </div>
        <div class="work-grid">
          <router-link
            v-for="item in featured"
            :key="item.title"
            :to="item.link"
            class="work-card"
          >
            <div class="work-thumb">
              <div class="work-thumb-inner" :style="item.cover" />
            </div>
            <div class="work-info">
              <div class="work-cat">{{ item.category }}</div>
              <div class="work-title">{{ item.title }}</div>
              <div class="work-desc">{{ item.desc }}</div>
            </div>
          </router-link>
        </div>
      </div>
    </section>

    <!-- INTERESTS -->
    <section class="interests">
      <div class="section-inner">
        <div class="section-label">03 — Interests</div>
        <div class="tag-cloud">
          <span v-for="t in tags" :key="t" class="tag">{{ t }}</span>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <section class="cta">
      <div class="section-inner cta-inner">
        <div>
          <div class="section-label">04 — Get in touch</div>
          <h2 class="cta-title">想聊点什么?</h2>
          <p class="cta-sub">合作、提问、或者单纯想认识一下,都行。</p>
        </div>
        <div class="cta-links">
          <a href="mailto:hello@xster.dev" class="cta-link">
            <span class="cta-link-label">Email</span>
            <span class="cta-link-value">hello@xster.dev</span>
          </a>
          <a href="https://github.com/Xster" target="_blank" rel="noopener" class="cta-link">
            <span class="cta-link-label">GitHub</span>
            <span class="cta-link-value">@Xster</span>
          </a>
          <router-link to="/contact" class="cta-link">
            <span class="cta-link-label">Contact</span>
            <span class="cta-link-value">留言页 →</span>
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "HomePage",
  data() {
    return {
      featured: [
        {
          title: "宝丽来移模",
          category: "Art · 视觉创作",
          desc: "把一张宝丽来底片的颜色转印到另一张上,做不可复制的颜色混合实验。",
          link: "/work",
          cover: { background: "linear-gradient(135deg, #f4d4b1 0%, #c98a6b 100%)" },
        },
        {
          title: "ColorRef",
          category: "Tool · 配色参考",
          desc: "为设计师做的配色速查工具,按色相/情绪/文化分组。",
          link: "/colors",
          cover: { background: "linear-gradient(135deg, #2c3e50 0%, #4ca1af 100%)" },
        },
        {
          title: "Excel Faker",
          category: "Tool · 效率",
          desc: "一键生成逼真的 Excel 测试数据,免去手动编造的痛苦。",
          link: "/excelfaker",
          cover: { background: "linear-gradient(135deg, #1d8348 0%, #52be80 100%)" },
        },
        {
          title: "HIIT Timer",
          category: "Life · 健身",
          desc: "给自己做的高强度间歇训练计时器,极简、可配。",
          link: "/hiit",
          cover: { background: "linear-gradient(135deg, #cb4335 0%, #f39c12 100%)" },
        },
        {
          title: "Chromosome",
          category: "Explore · 跨学科",
          desc: "用 Web 探索染色体结构,把分子生物学带进浏览器。",
          link: "/chromosome",
          cover: { background: "linear-gradient(135deg, #5b2c6f 0%, #a569bd 100%)" },
        },
        {
          title: "更多作品",
          category: "All Works",
          desc: "在 Discover 页面看完整宝丽来画廊。",
          link: "/work",
          cover: { background: "linear-gradient(135deg, #0a0a0a 0%, #404040 100%)" },
        },
      ],
      tags: [
        "Vue", "JavaScript", "Python", "Data Viz", "Polaroid",
        "Darkroom", "RDKit", "Genetics", "HIIT", "Photography",
        "Color Theory", "Bioinformatics", "Design Systems",
      ],
    };
  },
};
</script>

<style scoped>
.home {
  color: #0a0a0a;
}

/* ====== shared ====== */
.section-inner {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 24px;
}

.section-label {
  font-family: "JetBrains Mono", monospace;
  font-size: 0.75rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #888;
  margin-bottom: 32px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 32px;
}

.section-header .section-label {
  margin-bottom: 0;
}

.section-more {
  font-size: 0.9rem;
  color: #0a0a0a;
  text-decoration: none;
  border-bottom: 1px solid #0a0a0a;
  padding-bottom: 2px;
  transition: opacity 0.2s;
}

.section-more:hover {
  opacity: 0.6;
}

/* ====== HERO ====== */
.hero {
  min-height: calc(100vh - 64px);
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eaeaea;
}

.hero-inner {
  max-width: 1100px;
  margin: 0 auto;
  padding: 80px 24px;
  width: 100%;
}

.hero-eyebrow {
  font-family: "JetBrains Mono", monospace;
  font-size: 0.8rem;
  color: #888;
  margin-bottom: 32px;
  letter-spacing: 0.05em;
}

.hero-title {
  font-size: clamp(2.2rem, 5.5vw, 4.2rem);
  font-weight: 600;
  line-height: 1.15;
  letter-spacing: -0.03em;
  margin: 0 0 28px 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.hero-title-accent {
  font-style: italic;
  font-weight: 400;
  color: #555;
}

.hero-sub {
  font-family: "JetBrains Mono", monospace;
  font-size: 0.95rem;
  color: #555;
  margin: 0 0 40px 0;
  letter-spacing: 0.02em;
}

.hero-cta {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 64px;
}

.hero-meta {
  font-family: "JetBrains Mono", monospace;
  font-size: 0.8rem;
  color: #888;
  display: flex;
  align-items: center;
  gap: 8px;
}

.meta-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #1d8348;
  box-shadow: 0 0 0 0 rgba(29, 131, 72, 0.5);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% { box-shadow: 0 0 0 0 rgba(29, 131, 72, 0.5); }
  70% { box-shadow: 0 0 0 8px rgba(29, 131, 72, 0); }
  100% { box-shadow: 0 0 0 0 rgba(29, 131, 72, 0); }
}

/* ====== ABOUT ====== */
.about {
  padding: 120px 0;
  border-bottom: 1px solid #eaeaea;
}

.about-text {
  font-size: clamp(1.2rem, 2.2vw, 1.6rem);
  line-height: 1.6;
  letter-spacing: -0.01em;
  color: #1a1a1a;
  max-width: 800px;
  margin: 0;
}

.hl {
  background: linear-gradient(180deg, transparent 60%, #fff3a8 60%);
  padding: 0 2px;
}

/* ====== WORK ====== */
.work {
  padding: 120px 0;
  border-bottom: 1px solid #eaeaea;
}

.work-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 32px;
}

.work-card {
  text-decoration: none;
  color: inherit;
  display: block;
  transition: transform 0.3s ease;
}

.work-card:hover {
  transform: translateY(-4px);
}

.work-thumb {
  aspect-ratio: 4 / 3;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 16px;
  position: relative;
}

.work-thumb-inner {
  width: 100%;
  height: 100%;
  transition: transform 0.5s ease;
}

.work-card:hover .work-thumb-inner {
  transform: scale(1.05);
}

.work-cat {
  font-family: "JetBrains Mono", monospace;
  font-size: 0.72rem;
  color: #888;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 6px;
}

.work-title {
  font-size: 1.15rem;
  font-weight: 600;
  margin-bottom: 6px;
  letter-spacing: -0.01em;
}

.work-desc {
  font-size: 0.9rem;
  color: #555;
  line-height: 1.5;
}

/* ====== INTERESTS ====== */
.interests {
  padding: 120px 0;
  border-bottom: 1px solid #eaeaea;
}

.tag-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag {
  display: inline-block;
  padding: 6px 14px;
  border: 1px solid #eaeaea;
  border-radius: 999px;
  font-size: 0.85rem;
  color: #1a1a1a;
  transition: all 0.2s;
  cursor: default;
}

.tag:hover {
  background: #0a0a0a;
  color: #fff;
  border-color: #0a0a0a;
}

/* ====== CTA ====== */
.cta {
  padding: 120px 0 160px 0;
}

.cta-inner {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  align-items: start;
}

.cta-title {
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 600;
  letter-spacing: -0.02em;
  margin: 0 0 12px 0;
}

.cta-sub {
  font-size: 1rem;
  color: #555;
  margin: 0;
}

.cta-links {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.cta-link {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid #eaeaea;
  text-decoration: none;
  color: inherit;
  transition: padding 0.2s;
}

.cta-link:first-child {
  border-top: 1px solid #eaeaea;
}

.cta-link:hover {
  padding-left: 8px;
}

.cta-link-label {
  font-family: "JetBrains Mono", monospace;
  font-size: 0.75rem;
  color: #888;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.cta-link-value {
  font-size: 1rem;
  font-weight: 500;
}

/* ====== responsive ====== */
@media (max-width: 768px) {
  .hero { min-height: auto; }
  .hero-inner { padding: 60px 24px; }
  .about, .work, .interests, .cta { padding: 80px 0; }
  .cta-inner { grid-template-columns: 1fr; gap: 40px; }
  .work-grid { grid-template-columns: 1fr; }
  .section-header { flex-direction: column; align-items: flex-start; gap: 12px; }
}
</style>
